// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_wrk_ctx = require("../worker/MM_wrk_ctx.bs.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_parenCounter = require("../mm-utils/MM_parenCounter.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_substitution = require("../mm-utils/MM_substitution.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.bs.js");
var Button = require("@mui/material/Button").default;
var Expln_utils_jsonParse = require("@expln/utils/src/main/Expln_utils_jsonParse.bs.js");
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MM_cmp_merge_two_stmts = require("./MM_cmp_merge_two_stmts.bs.js");
var MM_cmp_save_or_discard = require("./MM_cmp_save_or_discard.bs.js");
var MM_cmp_unify_bottom_up = require("./MM_cmp_unify_bottom_up.bs.js");
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var IconButton = require("@mui/material/IconButton").default;
var Search = require("@mui/icons-material/Search").default;
var MergeType = require("@mui/icons-material/MergeType").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var Expln_React_ContentWithStickyHeader = require("@expln/utils/src/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var ControlPointDuplicate = require("@mui/icons-material/ControlPointDuplicate").default;

function userStmtLocStorToUserStmt(userStmtLocStor) {
  return {
          id: "",
          label: userStmtLocStor.label,
          labelEditMode: false,
          typ: MM_wrk_editor.userStmtTypeFromStr(userStmtLocStor.typ),
          typEditMode: false,
          cont: MM_wrk_editor.strToCont(userStmtLocStor.cont, undefined, undefined, undefined),
          contEditMode: false,
          jstfText: userStmtLocStor.jstfText,
          jstfEditMode: false,
          stmtErr: undefined,
          expr: undefined,
          jstf: undefined,
          proof: undefined,
          proofStatus: undefined
        };
}

var unifyAllIsRequiredCnt = {
  contents: 0
};

function createInitialEditorState(settingsV, settings, preCtxV, preCtx, stateLocStor) {
  var st_typeColors = Belt_HashMapString.make(0);
  var st_frms = MM_substitution.prepareFrmSubsData(preCtx);
  var st_parenCnt = MM_parenCounter.parenCntMake(MM_wrk_ctx.prepareParenInts(preCtx, settings.parens), undefined, undefined);
  var st_preCtxColors = Belt_HashMapString.make(0);
  var st_varsText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.varsText;
            })), "");
  var st_wrkCtxColors = Belt_HashMapString.make(0);
  var st_disjText = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.disjText;
            })), "");
  var st_disj = Belt_MapInt.fromArray([]);
  var st_nextStmtId = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (stateLocStor) {
              return stateLocStor.stmts.length;
            })), 0);
  var st_stmts = Belt_Option.getWithDefault(Belt_Option.map(stateLocStor, (function (obj) {
              return obj.stmts.map(function (stmtLocStor, i) {
                          var init = userStmtLocStorToUserStmt(stmtLocStor);
                          return {
                                  id: String(i),
                                  label: init.label,
                                  labelEditMode: init.labelEditMode,
                                  typ: init.typ,
                                  typEditMode: init.typEditMode,
                                  cont: init.cont,
                                  contEditMode: init.contEditMode,
                                  jstfText: init.jstfText,
                                  jstfEditMode: init.jstfEditMode,
                                  stmtErr: init.stmtErr,
                                  expr: init.expr,
                                  jstf: init.jstf,
                                  proof: init.proof,
                                  proofStatus: init.proofStatus
                                };
                        });
            })), []);
  var st_checkedStmtIds = [];
  var st_unifyAllIsRequiredCnt = unifyAllIsRequiredCnt.contents;
  var st = {
    settingsV: settingsV,
    settings: settings,
    typeColors: st_typeColors,
    preCtxV: preCtxV,
    preCtx: preCtx,
    frms: st_frms,
    parenCnt: st_parenCnt,
    preCtxColors: st_preCtxColors,
    varsText: st_varsText,
    varsEditMode: false,
    varsErr: undefined,
    wrkCtxColors: st_wrkCtxColors,
    disjText: st_disjText,
    disjEditMode: false,
    disjErr: undefined,
    disj: st_disj,
    wrkCtx: undefined,
    nextStmtId: st_nextStmtId,
    stmts: st_stmts,
    checkedStmtIds: st_checkedStmtIds,
    unifyAllIsRequiredCnt: st_unifyAllIsRequiredCnt
  };
  return MM_wrk_editor.updateColorsInAllStmts(MM_wrk_editor.recalcAllColors(st));
}

function editorStateToEditorStateLocStor(state) {
  return {
          varsText: state.varsText,
          disjText: state.disjText,
          stmts: state.stmts.map(function (stmt) {
                return {
                        label: stmt.label,
                        typ: stmt.typ,
                        cont: MM_wrk_editor.contToStr(stmt.cont),
                        jstfText: stmt.jstfText
                      };
              })
        };
}

function editorSaveStateToLocStor(state, key) {
  localStorage.setItem(key, Expln_utils_common.stringify(editorStateToEditorStateLocStor(state)));
}

function readEditorStateFromLocStor(key) {
  var stateLocStorStr = localStorage.getItem(key);
  if (stateLocStorStr === null) {
    return ;
  }
  var parseResult = Expln_utils_jsonParse.parseJson(stateLocStorStr, (function (__x) {
          return Expln_utils_jsonParse.asObj(__x, (function (d) {
                        return {
                                varsText: Expln_utils_jsonParse.str(d, "varsText", undefined, (function (param) {
                                        return "";
                                      }), undefined),
                                disjText: Expln_utils_jsonParse.str(d, "disjText", undefined, (function (param) {
                                        return "";
                                      }), undefined),
                                stmts: Expln_utils_jsonParse.arr(d, "stmts", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              label: Expln_utils_jsonParse.str(d, "label", undefined, undefined, undefined),
                                                              typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                              cont: Expln_utils_jsonParse.str(d, "cont", undefined, undefined, undefined),
                                                              jstfText: Expln_utils_jsonParse.str(d, "jstfText", undefined, undefined, undefined)
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, undefined, undefined)
                              };
                      }), undefined, undefined, undefined);
        }), undefined, undefined, undefined);
  if (parseResult.TAG === /* Ok */0) {
    return parseResult._0;
  }
  
}

function rndIconButton(icon, onClick, active, title, param) {
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

var stateLocStorKey = "editor-state";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function saveLastUsedTyp(ctx, typInt) {
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function MM_cmp_editor(Props) {
  var modalRef = Props.modalRef;
  var settingsV = Props.settingsV;
  var settings = Props.settings;
  var preCtxV = Props.preCtxV;
  var preCtx = Props.preCtx;
  var top = Props.top;
  var match = React.useState(function () {
        return createInitialEditorState(settingsV, settings, preCtxV, preCtx, readEditorStateFromLocStor(stateLocStorKey));
      });
  var setStatePriv = match[1];
  var state = match[0];
  var setState = function (update) {
    Curry._1(setStatePriv, (function (st) {
            var st$1 = MM_wrk_editor.updateEditorStateWithPostupdateActions(st, update);
            editorSaveStateToLocStor(st$1, stateLocStorKey);
            return st$1;
          }));
  };
  var editIsActive = state.varsEditMode || state.disjEditMode || state.stmts.some(function (stmt) {
        if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
          return true;
        } else {
          return stmt.jstfEditMode;
        }
      });
  var thereAreSyntaxErrors = MM_wrk_editor.editorStateHasErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = atLeastOneStmtIsChecked && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var generalModificationActionIsEnabled = !editIsActive && !thereAreSyntaxErrors;
  var atLeastOneStmtIsSelected = Belt_Option.getWithDefault(mainCheckboxState, true);
  var stmt = MM_wrk_editor.getTheOnlySelectedStmt(state);
  var singleProvableSelected = stmt !== undefined && stmt.typ === "p" ? stmt : undefined;
  var oneStatementIsSelected = state.checkedStmtIds.length === 1;
  var actSettingsUpdated = function (settingsV, settings) {
    setState(function (__x) {
          return MM_wrk_editor.setSettings(__x, settingsV, settings);
        });
  };
  React.useEffect((function () {
          actSettingsUpdated(settingsV, settings);
        }), [settingsV]);
  var actPreCtxUpdated = function (preCtxV, preCtx) {
    setState(function (__x) {
          return MM_wrk_editor.setPreCtx(__x, preCtxV, preCtx);
        });
  };
  React.useEffect((function () {
          actPreCtxUpdated(preCtxV, preCtx);
        }), [preCtxV]);
  var actAddNewStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st)[0];
        });
  };
  var actDeleteCheckedStmts = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: React.createElement(Expln_React_Column.make, {
                                      spacing: 1,
                                      children: null
                                    }, "Delete selected statements?", React.createElement(Expln_React_Row.make, {
                                          children: null
                                        }, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              children: "Cancel"
                                            }), React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                  setState(MM_wrk_editor.deleteCheckedStmts);
                                                }),
                                              variant: "contained",
                                              children: "Delete"
                                            })))
                              });
                  }));
          }));
  };
  var actMoveCheckedStmtsUp = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, true);
        });
  };
  var actMoveCheckedStmtsDown = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, false);
        });
  };
  var actDuplicateStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.duplicateCheckedStmt(st));
        });
  };
  var actBeginEdit0 = function (setter) {
    if (!editIsActive) {
      return setState(setter);
    }
    
  };
  var actBeginEdit = function (setter, stmtId) {
    if (!editIsActive) {
      return setState(function (__x) {
                  return Curry._2(setter, __x, stmtId);
                });
    }
    
  };
  var actCompleteEditLabel = function (stmtId, newLabel) {
    var newLabel$1 = newLabel.trim();
    var msg = MM_wrk_editor.renameStmt(state, stmtId, newLabel$1);
    if (msg.TAG !== /* Ok */0) {
      return MM_react_common.openInfoDialog(modalRef, "Cannot rename this statement: " + msg._0 + "", undefined, undefined);
    }
    var st = msg._0;
    setState(function (param) {
          return MM_wrk_editor.completeLabelEditMode(st, stmtId, newLabel$1);
        });
  };
  var actMergeTwoStmts = function (param) {
    if (state.checkedStmtIds.length !== 1) {
      return ;
    }
    var stmt1 = MM_wrk_editor.editorGetStmtById(state, Caml_array.get(state.checkedStmtIds, 0));
    if (stmt1 === undefined) {
      return ;
    }
    var contStr = MM_wrk_editor.contToStr(stmt1.cont);
    var stmt2 = state.stmts.find(function (stmt) {
          if (stmt.id !== stmt1.id) {
            return MM_wrk_editor.contToStr(stmt.cont) === contStr;
          } else {
            return false;
          }
        });
    if (stmt2 !== undefined) {
      if (MM_wrk_editor.contToStr(stmt1.cont) !== MM_wrk_editor.contToStr(stmt2.cont)) {
        return MM_react_common.openInfoDialog(modalRef, "Statements to merge must have identical expressions.", undefined, undefined);
      } else {
        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                    return null;
                  })), (function (modalId) {
                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                        return React.createElement(MM_cmp_merge_two_stmts.make, {
                                    stmt1: stmt1,
                                    stmt2: stmt2,
                                    onCancel: (function (param) {
                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                      }),
                                    onStmtSelected: (function (stmtToUse, stmtToRemove) {
                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                        setState(function (st) {
                                              var st$1 = MM_wrk_editor.mergeStmts(st, stmtToUse.id, stmtToRemove.id);
                                              if (st$1.TAG === /* Ok */0) {
                                                return MM_wrk_editor.uncheckAllStmts(st$1._0);
                                              }
                                              MM_react_common.openInfoDialog(modalRef, st$1._0, undefined, undefined);
                                              return st;
                                            });
                                      })
                                  });
                      }));
              }));
        return ;
      }
    } else {
      return MM_react_common.openInfoDialog(modalRef, "Cannot find another statement to merge with.", undefined, undefined);
    }
  };
  var actSearchAsrt = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                preCtxVer: state.preCtxV,
                                preCtx: state.preCtx,
                                parenStr: state.settings.parens,
                                varsText: state.varsText,
                                disjText: state.disjText,
                                hyps: state.stmts.filter(function (stmt) {
                                        return stmt.typ === "e";
                                      }).map(function (stmt) {
                                      return {
                                              id: stmt.id,
                                              label: stmt.label,
                                              text: MM_wrk_editor.contToStr(stmt.cont)
                                            };
                                    }),
                                wrkCtx: wrkCtx$1,
                                frms: state.frms,
                                initialTyp: getLastUsedTyp(state.preCtx),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtx, __x);
                                  }),
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedResults) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return selectedResults.reduce(MM_wrk_editor.addNewStatements, st);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSubstitute = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var expr1Init;
    if (state.checkedStmtIds.length >= 1) {
      var id = Caml_array.get(state.checkedStmtIds, 0);
      expr1Init = Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                    return stmt.id === id;
                  })), (function (stmt) {
              return MM_wrk_editor.contToStr(stmt.cont);
            }));
    } else {
      expr1Init = undefined;
    }
    var expr2Init;
    if (state.checkedStmtIds.length >= 2) {
      var id$1 = Caml_array.get(state.checkedStmtIds, 1);
      expr2Init = Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                    return stmt.id === id$1;
                  })), (function (stmt) {
              return MM_wrk_editor.contToStr(stmt.cont);
            }));
    } else {
      expr2Init = undefined;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_substitution.make, {
                                modalRef: modalRef,
                                editorState: state,
                                expr1Init: expr1Init,
                                expr2Init: expr2Init,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var actUnify = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var preCtxVer = state.preCtxV;
    var preCtx = state.preCtx;
    var parenStr = state.settings.parens;
    var varsText = state.varsText;
    var disjText = state.disjText;
    var hyps = state.stmts.filter(function (stmt) {
            return stmt.typ === "e";
          }).map(function (stmt) {
          return {
                  id: stmt.id,
                  label: stmt.label,
                  text: MM_wrk_editor.contToStr(stmt.cont)
                };
        });
    var stmts = MM_wrk_editor.getStmtsForUnification(state);
    if (singleProvableSelected !== undefined) {
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                      return React.createElement(MM_cmp_unify_bottom_up.make, {
                                  modalRef: modalRef,
                                  preCtxVer: preCtxVer,
                                  preCtx: preCtx,
                                  frms: state.frms,
                                  parenCnt: state.parenCnt,
                                  wrkCtx: wrkCtx$1,
                                  parenStr: parenStr,
                                  varsText: varsText,
                                  disjText: disjText,
                                  hyps: hyps,
                                  userStmtToProve: singleProvableSelected,
                                  stmts: stmts,
                                  typeToPrefix: Belt_MapString.fromArray(state.settings.typeSettings.map(function (ts) {
                                            return [
                                                    ts.typ,
                                                    ts.prefix
                                                  ];
                                          })),
                                  onResultSelected: (function (newStmtsDto) {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                      setState(function (st) {
                                            var st$1 = MM_wrk_editor.addNewStatements(st, newStmtsDto);
                                            return MM_wrk_editor.incUnifyAllIsRequiredCnt(MM_wrk_editor.uncheckAllStmts(st$1));
                                          });
                                    }),
                                  onCancel: (function (param) {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                    })
                                });
                    }));
            }));
    } else {
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return MM_react_common.rndProgress("Unifying all", 0, undefined, undefined);
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                      return MM_react_common.rndProgress("Unifying all", 0, (function (param) {
                                    return makeActTerminate(modalId, param);
                                  }), undefined);
                    }));
              return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, stmts, undefined, (function (msg) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return MM_react_common.rndProgress(msg, undefined, (function (param) {
                                                      return makeActTerminate(modalId, param);
                                                    }), undefined);
                                      }));
                              })), (function (proofTreeDto) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            Curry._1(setStatePriv, (function (st) {
                                    var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto);
                                    editorSaveStateToLocStor(st$1, stateLocStorKey);
                                    return st$1;
                                  }));
                          }));
            }));
    }
  };
  React.useEffect((function () {
          if (unifyAllIsRequiredCnt.contents < state.unifyAllIsRequiredCnt) {
            unifyAllIsRequiredCnt.contents = state.unifyAllIsRequiredCnt;
            if (!MM_wrk_editor.editorStateHasErrors(state)) {
              actUnify(undefined);
            }
            
          }
          
        }), [state.unifyAllIsRequiredCnt]);
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndButtons = function (param) {
    return React.createElement(Paper, {
                children: React.createElement(Expln_React_Row.make, {
                      children: null
                    }, React.createElement(Checkbox, {
                          disabled: editIsActive,
                          indeterminate: Belt_Option.isNone(mainCheckboxState),
                          checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                          onChange: (function (param) {
                              var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
                              Curry._1(setStatePriv, (function (st) {
                                      var st$1 = Curry._1(action, st);
                                      editorSaveStateToLocStor(st$1, stateLocStorKey);
                                      return st$1;
                                    }));
                            })
                        }), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), "Move selected statements down", undefined), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), "Move selected statements up", undefined), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, "Add new statement (and place before selected statements if any)", undefined), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsSelected, "Delete selected statements", undefined), rndIconButton(React.createElement(ControlPointDuplicate, {}), actDuplicateStmt, !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), "Duplicate selected statement", undefined), rndIconButton(React.createElement(MergeType, {
                              style: {
                                transform: "rotate(180deg)"
                              }
                            }), actMergeTwoStmts, oneStatementIsSelected, "Merge two similar statements", undefined), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && Belt_MapString.size(state.frms) > 0, "Add new statements from existing assertions (and place before selected statements if any)", undefined), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled && state.checkedStmtIds.length <= 2, "Apply a substitution to all statements", undefined), rndIconButton(React.createElement(Hub, {}), actUnify, generalModificationActionIsEnabled && (!atLeastOneStmtIsSelected || Belt_Option.isSome(singleProvableSelected)) && state.stmts.length > 0, "Unify all statements or unify selected provable bottom-up", undefined))
              });
  };
  var rndStmt = function (stmt) {
    return React.createElement("tr", {
                key: stmt.id
              }, React.createElement("td", {
                    style: {
                      verticalAlign: "top"
                    }
                  }, React.createElement(Checkbox, {
                        disabled: editIsActive,
                        checked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                        onChange: (function (param) {
                            var id = stmt.id;
                            Curry._1(setStatePriv, (function (st) {
                                    var st$1 = MM_wrk_editor.toggleStmtChecked(st, id);
                                    editorSaveStateToLocStor(st$1, stateLocStorKey);
                                    return st$1;
                                  }));
                          })
                      })), React.createElement("td", undefined, React.createElement(MM_cmp_user_stmt.make, {
                        stmt: stmt,
                        onLabelEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                          }),
                        onLabelEditDone: (function (newLabel) {
                            actCompleteEditLabel(stmt.id, newLabel);
                          }),
                        onLabelEditCancel: (function (newLabel) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var textOld = stmt$1.label;
                            if (textOld === newLabel || newLabel === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: textOld,
                                                          contNew: newLabel,
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              actCompleteEditLabel(stmtId, newLabel);
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onTypEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                          }),
                        onTypEditDone: (function (newTyp) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp);
                                });
                          }),
                        onContEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                          }),
                        onContEditDone: (function (newContText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                                });
                          }),
                        onContEditCancel: (function (newContText) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var contOld = stmt$1.cont;
                            var contNew = MM_wrk_editor.strToCont(newContText, undefined, undefined, undefined);
                            var textOld = MM_wrk_editor.contToStr(contOld);
                            var textNew = MM_wrk_editor.contToStr(contNew);
                            if (textOld === textNew) {
                              if (textOld === "") {
                                return setState(function (__x) {
                                            return MM_wrk_editor.deleteStmt(__x, stmtId);
                                          });
                              } else {
                                return setState(function (__x) {
                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                          });
                              }
                            } else if (textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: MM_cmp_user_stmt.rndContText(contOld),
                                                          removeStmt: textOld === "",
                                                          contNew: MM_cmp_user_stmt.rndContText(contNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              if (textOld === "") {
                                                                return setState(function (__x) {
                                                                            return MM_wrk_editor.deleteStmt(__x, stmtId);
                                                                          });
                                                              } else {
                                                                return setState(function (__x) {
                                                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                                                          });
                                                              }
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onJstfEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                          }),
                        onJstfEditDone: (function (newJstf) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                                });
                          }),
                        onJstfEditCancel: (function (newJstf) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var textOld = stmt$1.jstfText.trim();
                            var textNew = newJstf.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: textOld,
                                                          contNew: textNew,
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onGenerateProof: (function (param) {
                            var stmtId = stmt.id;
                            var proofText = MM_wrk_editor.generateCompressedProof(state, stmtId);
                            if (proofText !== undefined) {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(Paper, {
                                                          style: {
                                                            padding: "10px"
                                                          },
                                                          children: React.createElement(Expln_React_Column.make, {
                                                                children: null
                                                              }, React.createElement("pre", {
                                                                    style: {
                                                                      whiteSpace: "pre-wrap",
                                                                      overflowWrap: "break-word"
                                                                    }
                                                                  }, proofText), React.createElement(Button, {
                                                                    onClick: (function (param) {
                                                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                                                      }),
                                                                    children: "Close"
                                                                  }))
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                            
                          })
                      }), rndError(stmt.stmtErr)));
  };
  var rndVars = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Variables", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeVarsEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.varsText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          })
                      }), rndError(state.varsErr)));
  };
  var rndDisj = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Disjoints", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeDisjEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.disjText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          })
                      }), rndError(state.disjErr)));
  };
  var rndStmts = function (param) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, state.stmts.map(rndStmt)));
  };
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: top,
              header: rndButtons(undefined),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              children: null
                            }, rndVars(undefined), rndDisj(undefined), rndStmts(undefined));
                })
            });
}

var make = MM_cmp_editor;

exports.userStmtLocStorToUserStmt = userStmtLocStorToUserStmt;
exports.unifyAllIsRequiredCnt = unifyAllIsRequiredCnt;
exports.createInitialEditorState = createInitialEditorState;
exports.editorStateToEditorStateLocStor = editorStateToEditorStateLocStor;
exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.readEditorStateFromLocStor = readEditorStateFromLocStor;
exports.rndIconButton = rndIconButton;
exports.stateLocStorKey = stateLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.make = make;
/* react Not a pure module */
